import React from "react";
import { format, parseISO } from "date-fns";
import type { FleetDaySummary } from "./types";

interface FleetWeekSummaryProps {
  weekSummaries: FleetDaySummary[];
  onSelectDay: (dateStr: string) => void;
}

const FleetWeekSummary: React.FC<FleetWeekSummaryProps> = ({ weekSummaries, onSelectDay }) => {
  const maxJobs = Math.max(...weekSummaries.map((d) => d.jobCount), 1);

  return (
    <div className="border border-gray-700 rounded-lg overflow-hidden bg-gray-900/60 divide-y divide-gray-800">
      {weekSummaries.map((day) => (
        <button
          key={day.date}
          onClick={() => onSelectDay(day.date)}
          className="w-full flex items-center gap-4 px-4 py-3 hover:bg-gray-800/60 transition-colors text-left"
        >
          <div className="w-32 shrink-0">
            <p className="text-sm font-semibold text-white">{format(parseISO(day.date), "EEEE")}</p>
            <p className="text-xs text-gray-400">{format(parseISO(day.date), "d MMM yyyy")}</p>
          </div>
          <div className="w-28 shrink-0 text-xs text-gray-300">
            {day.vehiclesRostered} vehicle{day.vehiclesRostered !== 1 ? "s" : ""} rostered
          </div>
          <div className="flex-1 flex items-center gap-2">
            <div className="flex-1 h-3 bg-gray-800 rounded-full overflow-hidden">
              <div
                className="h-full bg-blue-500/70 rounded-full"
                style={{ width: `${(day.jobCount / maxJobs) * 100}%` }}
              />
            </div>
            <span className="text-xs text-gray-300 w-16 text-right">{day.jobCount} jobs</span>
          </div>
        </button>
      ))}
    </div>
  );
};

export default FleetWeekSummary;
